import axios from 'axios';

const ssoApi = axios.create({
  baseURL: process.env.REACT_APP_SSO_API_URL,
});

export async function login(email, password) {
  try {
    const response = await ssoApi.post('/login', { email, password });
    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function passwordResetEmail(email) {
  try {
    const response = await ssoApi.post('/password/email', { email });
    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
}
